'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SITES = exports.FillStatusPagePopup = exports.EVENT_TYPES = exports.LOGIN_WITH_TOKEN_END_POINT = exports.END_POINT = exports.NAME = undefined;

var _constants = require('./HTTP/constants');

var _translations = require('./translations');

var NAME = exports.NAME = 'PROPERA';
var END_POINT = exports.END_POINT = _constants.API_END_POINT + '/bootstrap';
var LOGIN_WITH_TOKEN_END_POINT = exports.LOGIN_WITH_TOKEN_END_POINT = _constants.API_END_POINT + '/loginWithToken';

var EVENT_TYPES = exports.EVENT_TYPES = {
  INFO: 'INFO',
  ERROR: 'ERROR',
  WARNING: 'WARNING'

  /**
  * An Alert (Warning) to be Displayed to Users if we have Incidents Reported in our StatusPage
   * https://status.freightos.com/
   * @type {{title: *, content: *}}
   */
};var FillStatusPagePopup = exports.FillStatusPagePopup = {
  message: (0, _translations.formatHTMLMessage)('statusPage/statusPageAlert', 'Freightos is experiencing technical difficulties. You can view the status <a href="https://status.freightos.com/" target="_blank">here</a>.'),
  level: 'warning',
  icon: 'warning',
  customIcon: '',
  autoClose: false,
  multiplePages: true
};

var SITES = exports.SITES = {
  ALIBABA: 'alibaba'
};